module.exports = __webpack_public_path__ + "static/media/Treasury.1dd24b61.mp4";